import React, {useEffect, useState} from 'react';
import {Button, Card, Divider, Input, Space, Table} from 'antd';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {MemberLevel, UserApi, UserDto} from '../../scaffold';
import {useAntdTable} from 'ahooks';
import AntDTableUtils from '../../utils/AntDTableUtils';
import {DefaultAntdTableConfig} from '../../utils/CommonConfig';
import moment from 'moment';
import UserViewBtn from '../../components/user/ViewBtn';
import UserEditBtn from '../../components/user/EditBtn';
import {useInput} from 'react-hanger';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import {SpecialtyCommitteeList} from '../../utils/CommitteeList';
import {CSVLink} from 'react-csv';
import useAuth from '../../utils/AuthContext';

export default function ManageUserListPage() {
  const searchHook = useOpenApiFpRequest(UserApi, UserApi.prototype.userSearchGet);
  const keywords = useInput('');
  const antdConfig = useAntdTable(
    params => {
      return searchHook.request({
        ...AntDTableUtils.makeParams(params),
        keywords: keywords.value,
      });
    },
    {...DefaultAntdTableConfig, refreshDeps: []},
  );
  const [commData, setCommData] = useState<string[][][]>([]);
  const header = ['ID', '会员名字', '手机号', '邮箱', '会员级别', '技术职称和级别', '注册日期', '会员有效期', '单位名称', '专委会01', '专委会02', '专委会03'];
  const auth = useAuth();
  useEffect(() => {
    searchHook
      .request({pi: 1, ps: 99999})
      .then(res => {
        const result: string[][][] = [];
        SpecialtyCommitteeList.forEach(comm => {
          const data: string[][] = [];
          const list =
            res.list?.filter(
              i =>
                i.personalApprove?.mainSpecialCommittee === comm ||
                i.personalApprove?.subSpecialCommittee01 === comm ||
                i.personalApprove?.subSpecialCommittee02 === comm,
            ) ?? [];
          list.forEach(i => {
            data.push([
              String(i.id),
              i.personalApprove?.name ?? '',
              i.telephone ?? '',
              i.personalApprove?.email ?? '',
              i.memberLevel ?? '',
              i.personalApprove?.levelFullTime ?? '',
              moment(i.registeredTime).format('YYYY-MM-DD'),
              moment(i.memberExpiredTime).format('YYYY-MM-DD'),
              i.personalApprove?.organizationFullTime ?? '',
              i.personalApprove?.mainSpecialCommittee ?? '',
              i.personalApprove?.subSpecialCommittee01 ?? '',
              i.personalApprove?.subSpecialCommittee02 ?? '',
            ]);
          });
          result.push(data);
        });
        setCommData(result);
      })
      .catch(CommonApiErrorHandler);
  }, []);
  return (
    <div className={'p-20'}>
      <Card title={'会员列表'}>
        <Input.Search {...keywords.eventBind} onSearch={antdConfig.refresh} style={{width: 300}} placeholder={'输入关键字筛选'} className={'m-b-10'} />
        {auth.currentUser?.isSu && commData.length > 0 && (
          <div>
            <Divider orientation={'left'}>导出各专委会</Divider>
            <div>
              {SpecialtyCommitteeList.map((comm, i) => (
                <CSVLink data={commData[i]} key={i} headers={header} filename={`${comm}.csv`}>
                  <Button className={'m-r-5'}>{comm}</Button>
                </CSVLink>
              ))}
            </div>
            <Divider />
          </div>
        )}
        <Table {...antdConfig.tableProps} pagination={{...antdConfig.tableProps.pagination, showTotal: v => `共 ${v} 条`}} size={'small'} bordered>
          <Table.Column title={'ID'} dataIndex={'id'} sorter key={'id'} />
          <Table.Column title={'会员名字'} dataIndex={['personalApprove', 'name']} />
          <Table.Column title={'手机号'} dataIndex={['telephone']} />
          <Table.Column<UserDto> title={'会员级别'} sorter key={'memberLevel'} render={(_, item) => item.memberLevel} />
          <Table.Column<UserDto> title={'技术职称和级别'} render={(_, item) => item.personalApprove?.levelFullTime} />
          <Table.Column<UserDto> title={'注册日期'} sorter key={'registeredTime'} render={(_, item) => moment(item.registeredTime).format('YYYY-MM-DD')} />
          <Table.Column<UserDto>
            title={'会员有效期'}
            sorter
            key={'memberExpiredTime'}
            render={(_, item) => moment(item.memberExpiredTime).format('YYYY-MM-DD')}
          />
          <Table.Column<UserDto> title={'单位名称'} render={(_, item) => item.personalApprove?.organizationFullTime} />
          <Table.Column<UserDto>
            title={'专委会'}
            render={(_, item) =>
              `${item.personalApprove?.mainSpecialCommittee},${item.personalApprove?.subSpecialCommittee01},${item.personalApprove?.subSpecialCommittee02}`
            }
          />
          <Table.Column<UserDto>
            title={'操作选项'}
            render={(_, item) => (
              <Space>
                <UserViewBtn user={item} size={'small'}>
                  查看
                </UserViewBtn>
                <UserEditBtn user={item} size={'small'} onSuccess={antdConfig.refresh}>
                  编辑
                </UserEditBtn>
              </Space>
            )}
          />
        </Table>
      </Card>
    </div>
  );
}
